import { Component, OnInit } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { REQUEST_STEPS } from '../../../enum-request-steps';
import { MarketPlaceQuoteRequestService } from '../../../../../../services/market-place-quote-request-service/market-place-quote-request.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from 'src/app/services/login-service/login.service';
import { draftQuoteRequest } from 'src/app/services/market-place-quote-request-service/draft-quote-request.service';
import { MixpanelService } from '../../../../../../services/mixpanel-service/mixpanel.service';
@Component({
  selector: 'app-general-cart-options',
  templateUrl: './general-cart-options.component.html',
  styleUrls: ['../../mechanical-options.component.scss'],
})
export class GeneralCartOptionsComponent implements OnInit {
  generalCartOptions: any;
  objGeneralCartOptions: any;

  private config: any = null;

  manwayLoading = false;

  liquidLoading = false;

  otherManwaySelected = false;
  manwayFilterText = '';
  newManwayGasketText = '';

  otherFlangeSelected = false;
  flangeFilterValue = '';
  newFlangeText = '';

  otherbovCapSelected = false;
  bovCapFilterValue = '';
  newbovCapText = '';

  oringFilterValue = '';
  newOringText = '';
  otherSelectedoRing = false;

  addinginteriorPrep = false;
  newinteriorPrepText = '';

  addingSpecialReq = false;
  newSpecialReqText = '';

  addinginteriorSurfacePrep = false;
  newinteriorSurfacePrepText = '';

  addingOxygenContent = false;
  newOxygenContentText = '';

  addingNitrogenPSI = false;
  newNitrogenPSIText = '';

  displayInteriorPrepHelp = false;
  addingLiningTypes = false;
  newLiningTypeText = '';

  editingManwayCoverGasket = false;
  newManwayCoverGaskeText = '';

  quoteRequest: any;

  generalCartForm = new FormGroup({
    'loading-type': new FormControl(null, [Validators.required]),
    'manway-type': new FormControl(null),
    'liquid-valve-type': new FormControl(null),
    'air-valve-fitting': new FormControl(null),
    'air-valve-type': new FormControl(null, [Validators.required]),
    'unloading-type': new FormControl(null, [Validators.required]),
    'bov-detail': new FormControl(null),
    'bov-aux-valve': new FormControl(null),
    'platform-reqs': new FormControl(null, [Validators.required]),
    'manway-gasket': new FormControl(null, [Validators.required]),
    'flange-gasket': new FormControl(null, [Validators.required]),
    'bov-gasket': new FormControl(null, [Validators.required]),
    'o-ring': new FormControl(null, [Validators.required]),
    'device-settings': new FormControl(null, [Validators.required]),
    'need-thermowell': new FormControl(null, [Validators.required]),
    'need-sample_line': new FormControl(null, [Validators.required]),
    'interior-prep': new FormControl(null, [Validators.required]),
    interior_surface_prep: new FormControl(null, [Validators.required]),
    'special-reqs': new FormControl(null, [Validators.required]),
    'lining-type': new FormControl(null, [Validators.required]),
    'oxygen-content': new FormControl(null, [Validators.required]),
    'nitrogen-psi': new FormControl(null, [Validators.required]),
    selected: new FormControl(true),
  });

  showAirValveFittings = false;

  constructor(
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private httpClient: HttpClient,
    private draftQuoteService: draftQuoteRequest,
    private mixpanelService: MixpanelService,
    private loginService: LoginService
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig) {
      this.config = JSON.parse(strConfig);
    }

    this.quoteRequestService.quoteRequest$.subscribe((value) => {
      this.quoteRequest = value;
      this.objGeneralCartOptions =
        value['mechanical-options']['general-service'];
      this.getOptions();
    });
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);

    this.generalCartForm.valueChanges.subscribe((value: any) => {
      // Check for loading type and add appropriate validators to the new form controls
      if (value['loading-type'] && value['loading-type'].length !== 0) {
        let chkStr = '';

        for (let i = 0; i < value['loading-type'].length; i++) {
          chkStr += value['loading-type'][i].name;
        }

        if (chkStr.includes('Manway')) {
          this.manwayLoading = true;
          this.generalCartForm.controls['manway-type']?.setValidators([
            Validators.required,
          ]);
        } else {
          this.manwayLoading = false;
          this.generalCartForm.controls['manway-type']?.setValidators([]);
        }

        if (chkStr.includes('Liquid Valve')) {
          this.liquidLoading = true;
          this.generalCartForm.controls['liquid-valve-type']?.setValidators([
            Validators.required,
          ]);
        } else {
          this.liquidLoading = false;
          this.generalCartForm.controls['liquid-valve-type']?.setValidators([]);
        }
      } else {
        this.generalCartForm.controls['manway-type']?.setValidators([]);
        this.generalCartForm.controls['liquid-valve-type']?.setValidators([]);
        this.liquidLoading = false;
        this.manwayLoading = false;
      }

      if (value['unloading-type'] !== 'Top Unloading') {
        this.generalCartForm.controls['bov-detail']?.setValidators([
          Validators.required,
        ]);

        if (value['bov-detail'] !== 'No Preference') {
          this.generalCartForm.controls['bov-aux-valve']?.setValidators([
            Validators.required,
          ]);
        } else {
          this.generalCartForm.controls['bov-aux-valve']?.setValidators([]);
        }
      } else {
        this.generalCartForm.controls['bov-detail']?.setValidators([]);
        this.generalCartForm.controls['bov-aux-valve']?.setValidators([]);
      }

      if (
        value['air-valve-type'] === null ||
        value['air-valve-type'].length === 0
      ) {
        this.showAirValveFittings = false;
        this.generalCartForm.controls['air-valve-fitting']?.setValidators([]);
      } else {
        if (value['air-valve-type'][0].name === 'None') {
          this.showAirValveFittings = false;
          this.generalCartForm.controls['air-valve-fitting']?.setValidators([]);
        } else {
          this.showAirValveFittings = true;
          this.generalCartForm.controls['air-valve-fitting']?.setValidators([
            Validators.required,
          ]);
        }
      }

      this.quoteRequest['mechanical-options']['general-service'] =
        this.createSubmittedObj();
    });

    this.subscribeToFormControlChanges();
  }

  private subscribeToFormControlChanges(): void {
    const formControls = this.generalCartForm.controls;

    Object.keys(formControls).forEach((controlName) => {
      formControls[controlName].valueChanges.subscribe((value) => {
        if (value) {
          this.trackFormControlChange(controlName, value);
        }
      });
    });
  }

  private trackFormControlChange(controlName: string, value: any): void {
    const userEmail = localStorage.getItem('userEmail');
    if (userEmail) {
      this.mixpanelService.init(userEmail);
      let eventName = '';
      let eventDisplayName = '';
      let eventDefinition = '';
      let parentEvent = '';
      let subParentEvent = '';

      switch (controlName) {
        case 'loading-type':
          eventName = 'How will these railcars be loaded?';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User changed the value of loading type`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Loading';
          break;
        case 'manway-type':
          eventName = 'Please select manway type';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User changed the value of manway type`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Loading';
          break;
        case 'liquid-valve-type':
          eventName = 'Please select liquid valve type';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User changed the value of liquid valve type`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Loading';
          break;
        case 'air-valve-type':
          eventName = 'What are your air valve requirements?';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User changed the value of air valve requirements`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Loading';
          break;
        case 'air-valve-fitting':
          eventName = 'Select air valve connection to fittings plate';
          eventDisplayName = value.name;
          eventDefinition = `User changed the value of air valve fittings`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Loading';
          break;
        case 'unloading-type':
          eventName = 'How will these railcars be unloaded?';
          eventDisplayName = value.name;
          eventDefinition = `User changed the value of unloading type`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Unloading';
          break;
        case 'bov-detail':
          eventName = 'Please select BOV detail';
          eventDisplayName = value.name;
          eventDefinition = `User changed the value of BOV detail`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Unloading';
          break;
        case 'bov-aux-valve':
          eventName = 'Please select BOV auxiliary valve';
          eventDisplayName = value.name;
          eventDefinition = `User changed the value of BOV auxiliary valve`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Unloading';
          break;
        case 'platform-reqs':
          eventName = 'Do you have platform requirements?';
          eventDisplayName = value.name;
          eventDefinition = `User changed the value of platform requirements`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Platform';
          break;
        case 'manway-gasket':
          eventName = 'Manway cover gasket';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User changed the value of manway cover gasket`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Gaskets & O-Rings';
          break;
        case 'flange-gasket':
          eventName = 'Flange gasket';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User changed the value of flange gasket`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Gaskets & O-Rings';
          break;
        case 'bov-gasket':
          eventName = 'BOV cap gasket';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User changed the value of BOV cap gasket`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Gaskets & O-Rings';
          break;
        case 'o-ring':
          eventName = 'O-ring';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User changed the value of O-ring`;
          parentEvent = 'Begin Quote';
          subParentEvent = 'Gaskets & O-Rings';
          break;
        case 'device-settings':
          eventName = 'Select magnetic gauging device settings';
          eventDisplayName = value.name;
          eventDefinition = `User changed the magnetic gauging device settings`;
          parentEvent = 'Fittings & Accessories';
          subParentEvent = 'Device Settings';
          break;
        case 'need-thermowell':
          eventName = 'Do you need a thermowell?';
          eventDisplayName = value.name;
          eventDefinition = `User changed the need for a thermowell`;
          parentEvent = 'Fittings & Accessories';
          subParentEvent = 'Thermowell';
          break;
        case 'need-sample_line':
          eventName = 'Do you need a sample line?';
          eventDisplayName = value.name;
          eventDefinition = `User changed the need for a sample line`;
          parentEvent = 'Fittings & Accessories';
          subParentEvent = 'Sample Line';
          break;
        case 'special-reqs':
          eventName = 'Does your product have any special requirements?';
          eventDisplayName = value.map((v: any) => v.name).join(', ');
          eventDefinition = `User specified special product requirements`;
          parentEvent = 'Interior Prep';
          subParentEvent = 'Special Requirements';
          break;
        case 'lining-type':
          eventName = ' What lining type do you prefer?';
          eventDisplayName = value.name;
          eventDefinition = `User selected the lining type`;
          parentEvent = 'Interior Prep';
          subParentEvent = 'Lining Type';
          break;
        case 'interior-prep':
          eventName = 'Interior prep';
          eventDisplayName = value.name;
          eventDefinition = `User selected interior prep`;
          parentEvent = 'Interior Prep';
          subParentEvent = 'Interior Prep';
          break;
        case 'interior_surface_prep':
          eventName = 'Interior surface prep';
          eventDisplayName = value.name;
          eventDefinition = `User selected interior surface prep`;
          parentEvent = 'Interior Prep';
          subParentEvent = 'Interior Surface Prep';
          break;
        case 'oxygen-content':
          eventName = 'Oxygen content';
          eventDisplayName = value.name;
          eventDefinition = `User selected oxygen content`;
          parentEvent = 'Purge & Pad';
          subParentEvent = 'Oxygen Content';
          break;
        case 'nitrogen-psi':
          eventName = 'Nitrogen PSI';
          eventDisplayName = value.name;
          eventDefinition = `User selected nitrogen PSI`;
          parentEvent = 'Purge & Pad';
          subParentEvent = 'Nitrogen PSI';
          break;
      }

      if (eventName !== '') {
        this.mixpanelService.track({
          eventName,
          eventDisplayName,
          kpi: 'User Engagement',
          trigger: 'On Input Change',
          eventDefinition,
          propertyType: 'Event Property',
          propertyDefinition: controlName,
          additionalProperties: {
            newValue: eventDisplayName,
            parentEvent,
            subParentEvent,
          },
        });
      }
    }
  }

  onChangeAirValveType(event: any) {
    var airValveOptions = [];
    if (event.itemValue.name === 'None') {
      airValveOptions = this.generalCartForm.value['air-valve-type'].filter(
        (x: any) => {
          return x.name === 'None';
        }
      );
    } else {
      airValveOptions = this.generalCartForm.value['air-valve-type'].filter(
        (x: any) => {
          return x.name !== 'None';
        }
      );
    }
    this.generalCartForm.controls['air-valve-type'].setValue(airValveOptions);
  }

  getOptions() {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    this.httpClient
      .post(this.config.leaseMechOptionsURL, {}, { headers: headers })
      .subscribe((data: any) => {
        this.generalCartOptions = data['mechanical-options']['general-service'];
        this.setGeneralForm();
      });
  }
  setGeneralForm() {
    this.generalCartForm.patchValue(this.objGeneralCartOptions);

    if (this.generalCartForm.value['manway-type'] === '') {
      this.generalCartForm.controls['manway-type'].setValue([
        this.generalCartOptions['manway-type'][0],
      ]);
    }

    if (this.generalCartForm.value['liquid-valve-type'] === '') {
      this.generalCartForm
        .get('liquid-valve-type')
        ?.setValue([this.generalCartOptions['liquid-valve-type'][0]]);
    }

    if (!this.generalCartForm.value['air-valve-type']) {
      this.generalCartForm.controls['air-valve-type'].setValue([
        this.generalCartOptions['air-valve-type'][0],
      ]);
    }

    if (this.generalCartForm.value['air-valve-fitting'] === '') {
      this.generalCartForm
        .get('air-valve-fitting')
        ?.setValue(this.generalCartOptions['air-valve-fitting'][0]);
    } else {
      const ds = this.generalCartOptions['air-valve-fitting'].filter(
        (item: any) =>
          item.id == this.objGeneralCartOptions['air-valve-fitting'].id
      );
      this.generalCartForm.get('air-valve-fitting')?.setValue(ds[0]);
    }

    if (this.generalCartForm.value['unloading-type'] === '') {
      this.generalCartForm
        .get('unloading-type')
        ?.setValue(this.generalCartOptions['unloading-type'][0]);
    } else {
      const ds = this.generalCartOptions['unloading-type'].filter(
        (item: any) =>
          item.id == this.objGeneralCartOptions['unloading-type'].id
      );
      this.generalCartForm.get('unloading-type')?.setValue(ds[0]);
    }

    if (this.generalCartForm.value['bov-detail'] === '') {
      this.generalCartForm
        .get('bov-detail')
        ?.setValue(this.generalCartOptions['bov-detail'][0]);
    } else {
      const ds = this.generalCartOptions['bov-detail'].filter(
        (item: any) => item.id == this.objGeneralCartOptions['bov-detail'].id
      );
      this.generalCartForm.get('bov-detail')?.setValue(ds[0]);
    }

    if (this.generalCartForm.value['bov-aux-valve'] === '') {
      this.generalCartForm
        .get('bov-aux-valve')
        ?.setValue(this.generalCartOptions['bov-aux-valve'][0]);
    } else {
      const ds = this.generalCartOptions['bov-aux-valve'].filter(
        (item: any) => item.id == this.objGeneralCartOptions['bov-aux-valve'].id
      );
      this.generalCartForm.get('bov-aux-valve')?.setValue(ds[0]);
    }

    if (this.generalCartForm.value['platform-reqs'] === '') {
      this.generalCartForm
        .get('platform-reqs')
        ?.setValue(this.generalCartOptions['platform-reqs'][0]);
    } else {
      const ds = this.generalCartOptions['platform-reqs'].filter(
        (item: any) => item.id == this.objGeneralCartOptions['platform-reqs'].id
      );
      this.generalCartForm.get('platform-reqs')?.setValue(ds[0]);
    }

    if (this.generalCartForm.value['manway-gasket'] === '') {
      this.generalCartForm
        .get('manway-gasket')
        ?.setValue([this.generalCartOptions['manway-gasket'][0]]);
    } else {
      // Add created 'Other' options
      this.generalCartOptions['manway-gasket'] = this.createOptionsArray(
        this.generalCartOptions['manway-gasket'],
        this.generalCartForm.value['manway-gasket']
      );
    }

    if (this.generalCartForm.value['flange-gasket'] === '') {
      this.generalCartForm
        .get('flange-gasket')
        ?.setValue([this.generalCartOptions['flange-gasket'][0]]);
    } else {
      // Add created 'Other' options
      this.generalCartOptions['flange-gasket'] = this.createOptionsArray(
        this.generalCartOptions['flange-gasket'],
        this.generalCartForm.value['flange-gasket']
      );
    }

    if (this.generalCartForm.value['bov-gasket'] === '') {
      this.generalCartForm
        .get('bov-gasket')
        ?.setValue([this.generalCartOptions['bov-gasket'][0]]);
    } else {
      // Add created 'Other' options
      this.generalCartOptions['bov-gasket'] = this.createOptionsArray(
        this.generalCartOptions['bov-gasket'],
        this.generalCartForm.value['bov-gasket']
      );
    }

    if (this.generalCartForm.value['o-ring'] === '') {
      this.generalCartForm
        .get('o-ring')
        ?.setValue([this.generalCartOptions['o-ring'][0]]);
    } else {
      // Add created 'Other' options
      this.generalCartOptions['o-ring'] = this.createOptionsArray(
        this.generalCartOptions['o-ring'],
        this.generalCartForm.value['o-ring']
      );
    }

    if (this.generalCartForm.value['device-settings'] === '') {
      this.generalCartForm
        .get('device-settings')
        ?.setValue(this.generalCartOptions['device-settings'][0]);
    } else {
      const ds = this.generalCartOptions['device-settings'].filter(
        (item: any) =>
          item.id == this.objGeneralCartOptions['device-settings'].id
      );
      this.generalCartForm.get('device-settings')?.setValue(ds[0]);
    }

    if (this.generalCartForm.value['need-thermowell'] === '') {
      this.generalCartForm
        .get('need-thermowell')
        ?.setValue(this.generalCartOptions['need-thermowell'][0]);
    } else {
      const vb = this.generalCartOptions['need-thermowell'].filter(
        (item: any) =>
          item.id == this.objGeneralCartOptions['need-thermowell'].id
      );
      this.generalCartForm.get('need-thermowell')?.setValue(vb[0]);
    }

    if (this.generalCartForm.value['need-sample_line'] === '') {
      this.generalCartForm
        .get('need-sample_line')
        ?.setValue(this.generalCartOptions['need-sample_line'][0]);
    } else {
      const vb = this.generalCartOptions['need-sample_line'].filter(
        (item: any) =>
          item.id == this.objGeneralCartOptions['need-sample_line'].id
      );
      this.generalCartForm.get('need-sample_line')?.setValue(vb[0]);
    }

    if (this.generalCartForm.value['special-reqs'] === '') {
      this.generalCartForm
        .get('special-reqs')
        ?.setValue([this.generalCartOptions['special-reqs'][0]]);
    } else {
      for (
        let i = 0;
        i < this.objGeneralCartOptions['special-reqs'].length;
        i++
      ) {
        if (
          this.objGeneralCartOptions['special-reqs'][i].id ===
          this.generalCartOptions['special-reqs'][
            this.generalCartOptions['special-reqs'].length - 1
          ].id
        ) {
          this.addingSpecialReq = true;
          this.newSpecialReqText =
            this.objGeneralCartOptions['special-reqs'][i].name.match(
              /\((.*)\)/
            )[1];
          this.generalCartOptions['special-reqs'][
            this.generalCartOptions['special-reqs'].length - 1
          ].name = this.objGeneralCartOptions['special-reqs'][i].name;
        }
      }
    }

    if (this.generalCartForm.value['lining-type'] === '') {
      this.generalCartForm
        .get('lining-type')
        ?.setValue(this.generalCartOptions['lining-type'][0]);
    } else {
      const vb = this.generalCartOptions['lining-type'].filter(
        (item: any) => item.id === this.objGeneralCartOptions['lining-type'].id
      );
      if (vb && vb.length > 0) {
        if (
          vb[0].id ===
          this.generalCartOptions['lining-type'][
            this.generalCartOptions['lining-type'].length - 1
          ].id
        ) {
          this.addingLiningTypes = true;
          this.newinteriorPrepText =
            this.objGeneralCartOptions['lining-type'].name.match(/\((.*)\)/)[1];
          vb[0].name = this.objGeneralCartOptions['lining-type'].name;
          this.generalCartForm.get('lining-type')?.setValue(vb[0]);
        } else {
          this.generalCartForm.get('lining-type')?.setValue(vb[0]);
        }
      }
    }

    if (this.generalCartForm.value['interior-prep'] === '') {
      this.generalCartForm
        .get('interior-prep')
        ?.setValue(this.generalCartOptions['interior-prep'][0]);
    } else {
      const vb = this.generalCartOptions['interior-prep'].filter(
        (item: any) =>
          item.id === this.objGeneralCartOptions['interior-prep'].id
      );
      if (vb && vb.length > 0) {
        if (
          vb[0].id ===
          this.generalCartOptions['interior-prep'][
            this.generalCartOptions['interior-prep'].length - 1
          ].id
        ) {
          this.addinginteriorPrep = true;
          this.newinteriorPrepText =
            this.objGeneralCartOptions['interior-prep'].name.match(
              /\((.*)\)/
            )[1];
          vb[0].name = this.objGeneralCartOptions['interior-prep'].name;
          this.generalCartForm.get('interior-prep')?.setValue(vb[0]);
        } else {
          this.generalCartForm.get('interior-prep')?.setValue(vb[0]);
        }
      }
    }

    if (this.generalCartForm.value['interior_surface_prep'] === '') {
      this.generalCartForm
        .get('interior_surface_prep')
        ?.setValue(this.generalCartOptions['interior_surface_prep'][0]);
    } else {
      const vb = this.generalCartOptions['interior_surface_prep'].filter(
        (item: any) =>
          item.id === this.objGeneralCartOptions['interior_surface_prep'].id
      );
      if (vb && vb.length > 0) {
        if (
          vb[0].id ===
          this.generalCartOptions['interior_surface_prep'][
            this.generalCartOptions['interior_surface_prep'].length - 1
          ].id
        ) {
          this.addinginteriorSurfacePrep = true;
          this.newinteriorSurfacePrepText =
            this.objGeneralCartOptions['interior_surface_prep'].name.match(
              /\((.*)\)/
            )[1];
          vb[0].name = this.objGeneralCartOptions['interior_surface_prep'].name;
          this.generalCartForm.get('interior_surface_prep')?.setValue(vb[0]);
        } else {
          this.generalCartForm.get('interior_surface_prep')?.setValue(vb[0]);
        }
      }
    }

    if (this.generalCartForm.value['oxygen-content'] === '') {
      this.generalCartForm
        .get('oxygen-content')
        ?.setValue(this.generalCartOptions['oxygen-content'][0]);
    } else {
      const vb = this.generalCartOptions['oxygen-content'].filter(
        (item: any) =>
          item.id == this.objGeneralCartOptions['oxygen-content'].id
      );

      if (vb && vb.length > 0) {
        if (
          vb[0].id ===
          this.generalCartOptions['oxygen-content'][
            this.generalCartOptions['oxygen-content'].length - 1
          ].id
        ) {
          this.addingOxygenContent = true;
          this.newOxygenContentText =
            this.objGeneralCartOptions['oxygen-content'].name.match(
              /\((.*)\)/
            )[1];
          vb[0].name = this.objGeneralCartOptions['oxygen-content'].name;
          this.generalCartForm.get('oxygen-content')?.setValue(vb[0]);
        } else {
          this.generalCartForm.get('oxygen-content')?.setValue(vb[0]);
        }
      }
    }

    if (this.generalCartForm.value['nitrogen-psi'] === '') {
      this.generalCartForm
        .get('nitrogen-psi')
        ?.setValue(this.generalCartOptions['nitrogen-psi'][0]);
    } else {
      const vb = this.generalCartOptions['nitrogen-psi'].filter(
        (item: any) => item.id == this.objGeneralCartOptions['nitrogen-psi'].id
      );

      if (vb && vb.length > 0) {
        if (
          vb[0].id ===
          this.generalCartOptions['nitrogen-psi'][
            this.generalCartOptions['nitrogen-psi'].length - 1
          ].id
        ) {
          this.addingNitrogenPSI = true;
          this.newNitrogenPSIText =
            this.objGeneralCartOptions['nitrogen-psi'].name.match(
              /\((.*)\)/
            )[1];
          vb[0].name = this.objGeneralCartOptions['nitrogen-psi'].name;
          this.generalCartForm.get('nitrogen-psi')?.setValue(vb[0]);
        } else {
          this.generalCartForm.get('nitrogen-psi')?.setValue(vb[0]);
        }
      }
    }
  }

  createSubmittedObj(): any {
    const obj = this.generalCartForm.value;
    this.quoteRequest['mechanical-options']['isValid'] =
      this.generalCartForm.valid;
    return obj;
  }

  checkLiningTypeValue(e: any, newLiningInput: HTMLInputElement) {
    if (e.value.name === 'Other') {
      this.addingLiningTypes = true;
      setTimeout(() => {
        newLiningInput.focus();
      }, 0);
    } else {
      this.addingLiningTypes = false;
    }
  }

  showAddManwayGasket(newManwayGasketInput: HTMLInputElement) {
    setTimeout(() => {
      newManwayGasketInput.focus();
    }, 0);
  }

  hideAddManwayGasket(manwayGasketSelect: MultiSelect) {
    if (manwayGasketSelect.filterValue === '---11') {
      setTimeout(() => {
        this.manwayFilterText = '';
      }, 0);
      this.focusFilterInput(manwayGasketSelect);
      this.otherManwaySelected = false;
    } else {
      this.focusFilterInput(manwayGasketSelect);
      this.otherManwaySelected = false;
    }
  }

  addNewManwayGasket(manwayGasketSelect: MultiSelect) {
    if (this.newManwayGasketText === '') {
      return;
    }

    const newLV = {
      id: this.generalCartOptions['manway-gasket'].length + 1,
      name: 'Other (' + this.newManwayGasketText + ')',
    };

    this.generalCartOptions['manway-gasket'].splice(
      this.generalCartOptions['manway-gasket'].length - 1,
      0,
      newLV
    );
    this.generalCartForm.controls['manway-gasket'].value.push(newLV);

    const aux = this.generalCartForm.controls['manway-gasket'].value;
    this.generalCartForm.controls['manway-gasket'].setValue([]);

    this.newManwayGasketText = '';

    this.otherManwaySelected = false;
    manwayGasketSelect.filterValue = '';
    this.manwayFilterText = '';
    setTimeout(() => {
      this.generalCartForm.controls['manway-gasket'].setValue(aux);
    }, 0);
  }

  checkManwayGasketValue(e: any, newManwayInput: HTMLInputElement) {
    if (
      e.itemValue.id ===
      this.generalCartOptions['manway-gasket'][
        this.generalCartOptions['manway-gasket'].length - 1
      ].id
    ) {
      this.showAddManwayGasket(newManwayInput);
      this.otherManwaySelected = true;
      this.generalCartForm.get('manway-gasket')?.value.pop();
      setTimeout(() => {
        this.manwayFilterText = '---11';
      });
    }

    if (e.itemValue.name.includes('Other (')) {
      const index = this.generalCartOptions['manway-gasket'].indexOf(
        this.generalCartOptions['manway-gasket'].find(
          (item: any) => item.id === e.itemValue.id
        )
      );

      if (index > 0) {
        this.generalCartOptions['manway-gasket'].splice(index, 1);
      }
    }
  }

  checkFlangeValue(e: any, newFlangeInput: HTMLInputElement) {
    if (
      e.itemValue.id ===
      this.generalCartOptions['flange-gasket'][
        this.generalCartOptions['flange-gasket'].length - 1
      ].id
    ) {
      this.showAddFlange(newFlangeInput);
      this.otherFlangeSelected = true;
      this.generalCartForm.get('flange-gasket')?.value.pop();
      setTimeout(() => {
        this.flangeFilterValue = '---11';
      });
    }

    if (e.itemValue.name.includes('Other (')) {
      const index = this.generalCartOptions['flange-gasket'].indexOf(
        this.generalCartOptions['flange-gasket'].find(
          (item: any) => item.id === e.itemValue.id
        )
      );

      if (index > 0) {
        this.generalCartOptions['flange-gasket'].splice(index, 1);
      }
    }
  }

  checkOringValue(e: any, newOringInput: HTMLInputElement) {
    if (
      e.itemValue.id ===
      this.generalCartOptions['o-ring'][
        this.generalCartOptions['o-ring'].length - 1
      ].id
    ) {
      this.showAddOring(newOringInput);
      this.otherSelectedoRing = true;
      this.generalCartForm.get('o-ring')?.value.pop();
      setTimeout(() => {
        this.oringFilterValue = '---11';
      });
    }

    if (e.itemValue.name.includes('Other (')) {
      const index = this.generalCartOptions['o-ring'].indexOf(
        this.generalCartOptions['o-ring'].find(
          (item: any) => item.id === e.itemValue.id
        )
      );

      if (index > 0) {
        this.generalCartOptions['o-ring'].splice(index, 1);
      }
    }
  }

  showAddFlange(newFlangeInput: HTMLInputElement) {
    setTimeout(() => {
      newFlangeInput.focus();
    }, 0);
  }

  showAddOring(newOringInput: HTMLInputElement) {
    setTimeout(() => {
      newOringInput.focus();
    }, 0);
  }

  hideAddFlange(flangeGasketSelect: MultiSelect) {
    if (flangeGasketSelect.filterValue === '---11') {
      setTimeout(() => {
        this.flangeFilterValue = '';
      }, 0);
      this.focusFilterInput(flangeGasketSelect);
      this.otherFlangeSelected = false;
    } else {
      this.focusFilterInput(flangeGasketSelect);
      this.otherFlangeSelected = false;
    }
  }

  hideAddOring(oringSelect: MultiSelect) {
    if (oringSelect.filterValue === '---11') {
      setTimeout(() => {
        this.oringFilterValue = '';
      }, 0);
      this.focusFilterInput(oringSelect);
      this.otherSelectedoRing = false;
    } else {
      this.focusFilterInput(oringSelect);
      this.otherSelectedoRing = false;
    }
  }

  addNewFlange(flangeGasketSelect: MultiSelect) {
    if (this.newFlangeText === '') {
      return;
    }

    const newFlange = {
      id: this.generalCartOptions['flange-gasket'].length + 1,
      name: 'Other (' + this.newFlangeText + ')',
    };

    this.generalCartOptions['flange-gasket'].splice(
      this.generalCartOptions['flange-gasket'].length - 1,
      0,
      newFlange
    );
    this.generalCartForm.controls['flange-gasket'].value.push(newFlange);

    const aux = this.generalCartForm.controls['flange-gasket'].value;
    this.generalCartForm.controls['flange-gasket'].setValue([]);

    this.newFlangeText = '';

    this.otherFlangeSelected = false;
    flangeGasketSelect.filterValue = '';
    this.flangeFilterValue = '';
    setTimeout(() => {
      this.generalCartForm.controls['flange-gasket'].setValue(aux);
    }, 0);
  }

  addNewOring(oringSelect: MultiSelect) {
    if (this.newOringText === '') {
      return;
    }

    const newOring = {
      id: this.generalCartOptions['o-ring'].length + 1,
      name: 'Other (' + this.newOringText + ')',
    };

    this.generalCartOptions['o-ring'].splice(
      this.generalCartOptions['o-ring'].length - 1,
      0,
      newOring
    );

    this.generalCartForm.controls['o-ring'].value.push(newOring);

    const aux = this.generalCartForm.controls['o-ring'].value;
    this.generalCartForm.controls['o-ring'].setValue([]);

    this.newOringText = '';

    this.otherSelectedoRing = false;
    oringSelect.filterValue = '';
    this.oringFilterValue = '';
    setTimeout(() => {
      this.generalCartForm.controls['o-ring'].setValue(aux);
    }, 0);
  }

  showAddbovCap(newBovCapInput: HTMLInputElement) {
    this.otherbovCapSelected = true;

    setTimeout(() => {
      newBovCapInput.focus();
    }, 0);
  }

  hideAddbovCap(bovCapSelect: MultiSelect) {
    if (bovCapSelect.filterValue === '---11') {
      setTimeout(() => {
        this.bovCapFilterValue = '';
      }, 0);
      this.focusFilterInput(bovCapSelect);
      this.otherbovCapSelected = false;
    } else {
      this.focusFilterInput(bovCapSelect);
      this.otherbovCapSelected = false;
    }
  }

  addNewbovCap(bovCapSelect: MultiSelect) {
    if (this.newbovCapText === '') {
      return;
    }

    const newLV = {
      id: this.generalCartOptions['bov-gasket'].length + 1,
      name: 'Other (' + this.newbovCapText + ')',
    };

    this.generalCartOptions['bov-gasket'].splice(
      this.generalCartOptions['bov-gasket'].length - 1,
      0,
      newLV
    );
    this.generalCartForm.controls['bov-gasket'].value.push(newLV);

    const aux = this.generalCartForm.controls['bov-gasket'].value;
    this.generalCartForm.controls['bov-gasket'].setValue([]);

    this.newbovCapText = '';

    this.otherbovCapSelected = false;
    bovCapSelect.filterValue = '';
    this.bovCapFilterValue = '';
    setTimeout(() => {
      this.generalCartForm.controls['bov-gasket'].setValue(aux);
    }, 0);
  }

  checkbovCapValue(e: any, newBovCapInput: HTMLInputElement) {
    if (
      e.itemValue.id ===
      this.generalCartOptions['bov-gasket'][
        this.generalCartOptions['bov-gasket'].length - 1
      ].id
    ) {
      this.showAddbovCap(newBovCapInput);
      this.generalCartForm.get('bov-gasket')?.value.pop();
      setTimeout(() => {
        this.bovCapFilterValue = '---11';
      });
    }

    if (e.itemValue.name.includes('Other (')) {
      const index = this.generalCartOptions['bov-gasket'].indexOf(
        this.generalCartOptions['bov-gasket'].find(
          (item: any) => item.id === e.itemValue.id
        )
      );

      if (index > 0) {
        this.generalCartOptions['bov-gasket'].splice(index, 1);
      }
    }
  }

  focusFilterInput(multiSelect: MultiSelect) {
    setTimeout(() => {
      multiSelect.filterInputChild.nativeElement.focus();
      if (multiSelect.filterValue === '---11') {
        switch (multiSelect.inputId) {
          case 'manway': {
            this.hideAddManwayGasket(multiSelect);
            break;
          }

          case 'flange': {
            this.hideAddFlange(multiSelect);
            break;
          }

          case 'bovCap': {
            this.hideAddbovCap(multiSelect);
            break;
          }

          case 'oring': {
            this.hideAddOring(multiSelect);
            break;
          }
        }
      }
    }, 0);
  }

  checkSpecialReqValue(e: any, newSpecialReqInput: HTMLInputElement) {
    let checkStr = '';

    for (const checkedElement of e.checked) {
      checkStr += checkedElement.name;
    }

    if (e.checked.length > 1 && e.checked[0].name === 'None') {
      this.generalCartForm.get('special-reqs')?.value.splice(0, 1);
    }

    if (checkStr.includes('Other') || checkStr.includes('other')) {
      this.addingSpecialReq = true;
      setTimeout(() => {
        newSpecialReqInput.focus();
      }, 0);
    } else {
      this.addingSpecialReq = false;
    }
  }

  addingOtherValue(type: string) {
    switch (type) {
      case 'LiningType': {
        if (this.newLiningTypeText !== '') {
          this.generalCartForm.controls['lining-type'].value.name =
            'Other (' + this.newLiningTypeText + ')';
        } else {
          this.generalCartForm.controls['lining-type'].value.name = 'Other';
        }

        break;
      }

      case 'SpecialReq': {
        if (this.newSpecialReqText !== '') {
          this.generalCartOptions['special-reqs'][
            this.generalCartOptions['special-reqs'].length - 1
          ].name = 'Other (' + this.newSpecialReqText + ')';
        } else {
          this.generalCartOptions['special-reqs'][
            this.generalCartOptions['special-reqs'].length - 1
          ].name = 'Other';
        }

        break;
      }

      case 'InteriorPrep': {
        if (this.newinteriorPrepText !== '') {
          this.generalCartForm.controls['interior-prep'].value.name =
            'Other (' + this.newinteriorPrepText + ')';
        } else {
          this.generalCartForm.controls['interior-prep'].value.name = 'Other';
        }

        break;
      }

      case 'InteriorSurfacePrep': {
        if (this.newinteriorSurfacePrepText !== '') {
          this.generalCartForm.controls['interior_surface_prep'].value.name =
            'Other (' + this.newinteriorSurfacePrepText + ')';
        } else {
          this.generalCartForm.controls['interior_surface_prep'].value.name =
            'Other';
        }

        break;
      }

      case 'OxygenContent': {
        if (this.newOxygenContentText !== '') {
          this.generalCartForm.controls['oxygen-content'].value.name =
            'Other (' + this.newOxygenContentText + ')';
        } else {
          this.generalCartForm.controls['oxygen-content'].value.name = 'Other';
        }

        break;
      }

      case 'NitrogenPSI': {
        if (this.newNitrogenPSIText !== '') {
          this.generalCartForm.controls['nitrogen-psi'].value.name =
            'Other (' + this.newNitrogenPSIText + ')';
        } else {
          this.generalCartForm.controls['nitrogen-psi'].value.name = 'Other';
        }

        break;
      }
    }
  }

  checkRadioOtherValue(eventValue: any, radioGroup: string) {
    switch (radioGroup) {
      case 'InteriorPrep': {
        this.addinginteriorPrep =
          eventValue.id ===
          this.generalCartOptions['interior-prep'][
            this.generalCartOptions['interior-prep'].length - 1
          ].id;

        break;
      }

      case 'InteriorSurfacePrep': {
        this.addinginteriorSurfacePrep =
          eventValue.id ===
          this.generalCartOptions['interior_surface_prep'][
            this.generalCartOptions['interior_surface_prep'].length - 1
          ].id;

        break;
      }

      case 'OxygenContent': {
        this.addingOxygenContent =
          eventValue.id ===
          this.generalCartOptions['oxygen-content'][
            this.generalCartOptions['oxygen-content'].length - 1
          ].id;
        break;
      }

      case 'NitrogenPSI': {
        this.addingNitrogenPSI =
          eventValue.id ===
          this.generalCartOptions['nitrogen-psi'][
            this.generalCartOptions['nitrogen-psi'].length - 1
          ].id;
        break;
      }
    }
  }

  addTextBreakline(name: string) {
    const splitSpace = name.split(' ');
    return splitSpace[0] + '<br>' + splitSpace[1];
  }

  next() {
    this.quoteRequest['mechanical-options']['general-service'] =
      this.generalCartForm.value;
    this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.LEASING_OPTIONS);
    this.draftQuoteService.saveDraftQuation(REQUEST_STEPS.LEASING_OPTIONS);
  }

  back() {
    this.quoteRequest['mechanical-options']['general-service'] =
      this.generalCartForm.value;
    this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.SELECTION);
  }

  private createOptionsArray(options: any, values: any) {
    if (values.length > options.length) {
      return values;
    }

    const array = options;
    const dif = values.filter((e: any) => {
      return !options.some((item: any) => item.id === e.id);
    });

    array.splice(array.length - 1, 0, ...dif);

    return array;
  }
}
